module.exports = __webpack_public_path__ + "img/icon-31.b2b7c262.png";